import { configureStore, Action } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
// import { createBrowserHistory } from 'history'

import rootReducer, { RootState } from "./rootReducer";

// export const history = createBrowserHistory()

const getStore = () =>
  configureStore({
    reducer: rootReducer(),
    middleware: (getDefaultMiddleware: any) =>
      getDefaultMiddleware({
        serializableCheck: false, // Next JS migration change
      }),
  });

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default getStore;
